import { useEffect } from "react";

import { AppProvider } from "@/providers/AppProvider";
import { AppRoutes } from "@/routes";
import { injectGoCamIfNeeded } from "@/lib/gocam";

export default function App() {
  useEffect(() => {
    injectGoCamIfNeeded();
  }, []);

  return (
    <AppProvider>
      <AppRoutes />
    </AppProvider>
  );
}
